(function () {
  const root = document.querySelector(".tabs-filter--root");
  if (!root) return;

  const ITEMS_PER_PAGE = parseInt(root.dataset.itemsPerPage, 10) || 6;
  const wrapper = root.querySelector(".tabs-content--wrapper");
  const btnContainer = root.querySelector("#myBtnContainer");
  const buttons = btnContainer ? Array.from(btnContainer.querySelectorAll("button")) : [];
  const paginationEl = root.querySelector("#tab-pagina");
  const paginationContainer = root.querySelector(".tab-pagina-container");

  if (!paginationEl) return;

  let currentPage = 1;

  function getItems() {
    return Array.from(root.querySelectorAll(".tabs-content--block"));
  }

  function getVisibleItems() {
    return getItems().filter((item) => item.classList.contains("show"));
  }

  function hideAllItems() {
    getItems().forEach((item) => {
      item.classList.remove("active");
      item.style.display = "none";
    });
  }

  function showPage(page) {
    const visibleItems = getVisibleItems();
    const totalPages = Math.max(1, Math.ceil(visibleItems.length / ITEMS_PER_PAGE));

    currentPage = Math.min(Math.max(1, page), totalPages);

    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    const end = start + ITEMS_PER_PAGE;

    hideAllItems();

    visibleItems.slice(start, end).forEach((item) => {
      item.classList.add("active");
      item.style.display = "";
    });

    renderPagination();
  }

  function createPageItem(label, page, isActive = false, isDisabled = false) {
    const li = document.createElement("li");
    li.className = `page-item${isActive ? " active" : ""}${isDisabled ? " disabled" : ""}`;

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "page-link";
    btn.innerHTML = label;

    if (isDisabled) {
      btn.disabled = true;
    } else {
      btn.addEventListener("click", function () {
        showPage(page);
      });
    }

    li.appendChild(btn);
    return li;
  }

  function renderPagination() {
    const visibleItems = getVisibleItems();
    const totalPages = Math.max(1, Math.ceil(visibleItems.length / ITEMS_PER_PAGE));

    paginationEl.innerHTML = "";

    if (paginationContainer) {
      paginationContainer.style.border = totalPages <= 1 ? "none" : "";
      paginationContainer.style.display = totalPages <= 1 ? "none" : "";
    }

    if (totalPages <= 1) return;

    paginationEl.appendChild(
      createPageItem("Previous", currentPage - 1, false, currentPage === 1)
    );

    for (let page = 1; page <= totalPages; page++) {
      paginationEl.appendChild(
        createPageItem(String(page), page, page === currentPage, false)
      );
    }

    paginationEl.appendChild(
      createPageItem("Next", currentPage + 1, false, currentPage === totalPages)
    );
  }

  function applyFilter(filter) {
    const normalizedFilter = filter === "all" ? "" : filter;

    getItems().forEach((item) => {
      const matches = !normalizedFilter || item.classList.contains(normalizedFilter);

      item.classList.remove("show", "active");
      item.style.display = "none";

      if (matches) {
        item.classList.add("show");
      }
    });

    if (wrapper && window.jQuery) {
      window.jQuery(wrapper).stop(true, true).fadeIn("slow");
    }

    showPage(1);
  }

  window.filterSelection = applyFilter;

  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      buttons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");
    });
  });

  const hasPreShownItems = getItems().some((item) => item.classList.contains("show"));
  if (!hasPreShownItems) {
    getItems().forEach((item) => item.classList.add("show"));
  }

  showPage(1);
})();